import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { Routes } from '@angular/router';
import { clientInterceptorInterceptor } from './client/client-interceptor.interceptor';
import { adminInterceptor } from './admin/admin-interceptor.interceptor';

export const routes: Routes = [
    {
       
        path: 'admin',
        loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
    },
    {
        path: 'login',
        loadChildren: () => import('./client/client.module').then(m => m.ClientModule),
       
    },
    {
        path: 'termos-e-condicoes',
        loadComponent: ()=> import('./client/term-info/term-info.component').then(c => c.TermInfoComponent)
    },
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    

];
